export default function TosTab() {
  return (
    <div data-testid="tos-tab" className="prose prose-invert max-w-2xl text-slate-300 text-xs space-y-3">
      <h3 className="text-lg font-bold text-white">Terms of Service</h3>
      <p className="text-[11px] text-slate-500">Last updated: Feb 2026</p>

      <section>
        <h4 className="text-sm font-bold text-amber-300 mb-1">1. Educational Purpose</h4>
        <p>InstitutionalSandbox is a simulated trading environment for education only. Nothing on this platform constitutes financial advice. Past simulated performance does not predict future real-money results.</p>
      </section>

      <section>
        <h4 className="text-sm font-bold text-amber-300 mb-1">2. Account & Conduct</h4>
        <ul className="list-disc pl-5 space-y-1">
          <li>One account per person. Multi-accounting may result in immediate ban without refund.</li>
          <li>You agree not to post slurs, threats, self-harm material, sexual content, or other prohibited speech in any chat surface.</li>
          <li>Spam, scams, and impersonation of admins are grounds for permanent ban.</li>
          <li>The platform may freeze chat, mute, or remove content at any time without prior notice.</li>
        </ul>
      </section>

      <section>
        <h4 className="text-sm font-bold text-amber-300 mb-1">3. Subscriptions & Refunds</h4>
        <ul className="list-disc pl-5 space-y-1">
          <li>Pro ($19/mo) and Elite ($49/mo) tiers renew monthly until cancelled.</li>
          <li>Guild creation costs $5/mo per guild. Lapsed guilds freeze for 14 days then dissolve.</li>
          <li>One-time Store purchases (badges, name colors, music upload unlock) are non-refundable.</li>
          <li>Cancel anytime via Account → Subscription.</li>
        </ul>
      </section>

      <section>
        <h4 className="text-sm font-bold text-amber-300 mb-1">4. Data & Privacy</h4>
        <p>We store: email, password hash, your trades, chat messages, voice clips, badges. We never sell your data. You may delete your account anytime by contacting support.</p>
      </section>

      <section>
        <h4 className="text-sm font-bold text-amber-300 mb-1">5. Admin Authority</h4>
        <p>Admins and the Owner may mute, ban, dissolve guilds, freeze global chat, or remove messages at their sole discretion. The Owner account is immutable.</p>
      </section>

      <section>
        <h4 className="text-sm font-bold text-amber-300 mb-1">6. Liability</h4>
        <p>Platform is provided "as is" with no warranty. The operators are not liable for losses arising from real-money trading you choose to do based on what you learned here.</p>
      </section>

      <section>
        <h4 className="text-sm font-bold text-amber-300 mb-1">7. Contact</h4>
        <p>support@ictsim.com — replies within 24 hours.</p>
      </section>

      <div className="text-[10px] text-slate-600 italic mt-4">By using InstitutionalSandbox you agree to these terms. Continued use after updates constitutes acceptance.</div>
    </div>
  );
}
